
<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>Kundtjänst</v-card-title>    
        <v-card-text>
          <v-row>
            <v-col>
              <v-list>
                <v-subheader>Meny</v-subheader>
                <v-list-item-group>
                  <v-list-item v-for="(item, i) in items" :key="i" :to="item.route">           
                    <v-list-item-icon>
                      <v-icon v-text="item.icon" />
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>                                        
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <Shortcut />
    </v-col>  
  </v-row>
</template>

<script>
import Shortcut from '@/components/admin/Shortcuts'
export default {
name:'Start',
components:{Shortcut},
data:()=>({
  items: [       
        { title:'Meddelanden',route:{name:'messages',},icon:'message'},
        { title:'Dagens produkter', route:{name:'dailyproducts', },icon:'today'},
        { title: 'Buntar',  route:{name:'bundles',}, icon:'newspaper'	 },
        { title: 'Helgspärr',  route:{name:'holidays',}, icon:'calendar_month'	 },
        { title: 'Produkt information',  route:{name:'products',}, icon:'newspaper'	 },
        { title: 'Fakturering',  route:{name:'invoice',}, icon:'paid'	 },       
        { title: 'Garantibelopp',  route:{name:'guarantees',}, icon:'money'	 },       
        { title: 'MiniDeb',  route:{name:'minideb',}, icon:'block '	 },       
      ],
})
}
</script>

<style>

</style>